import { gameReady } from '../state/connection';
import { BottomToolbar } from './components/BottomToolbar';
import { ColonistBar } from './components/ColonistBar';
import { ColonyLostOverlay } from './components/ColonyLostOverlay';
import { ConnectionStatus } from './components/ConnectionStatus';
import { ConstructionDetailsPanel } from './components/ConstructionDetailsPanel';
import { ConstructionPanel } from './components/ConstructionPanel';
import { ContextMenu } from './components/ContextMenu';
import { ControlsOverlay } from './components/ControlsOverlay';
import { CraftingPanel } from './components/CraftingPanel';
import { DebugOverlay } from './components/DebugOverlay';
import { ErrorOverlay } from './components/ErrorOverlay';
import { EscMenu } from './components/EscMenu';
import { FightModeToggle } from './components/FightModeToggle';
import { GamePanel } from './components/GamePanel';
import { NpcInfoPanel } from './components/NpcInfoPanel';
import { QuestsPanel } from './components/QuestsPanel';
import { StockpilePanel } from './components/StockpilePanel';
import { TerritoryInfoPanel } from './components/TerritoryInfoPanel';
import { WelcomeSplash } from './components/WelcomeSplash';
import { XpDrops } from './components/XpDrops';

export const App = () => {
  return (
    <div id="game-ui">
      <WelcomeSplash />
      <ErrorOverlay />
      <ConnectionStatus />
      {gameReady.value && (
        <>
          <ColonyLostOverlay />
          <ControlsOverlay />
          <EscMenu />
          <QuestsPanel />
          <DebugOverlay />
          <ColonistBar />
          <XpDrops />
          <NpcInfoPanel />
          <TerritoryInfoPanel />
          <GamePanel />
          <ConstructionDetailsPanel />
          <ConstructionPanel />
          <StockpilePanel />
          <CraftingPanel />
          <BottomToolbar />
          <FightModeToggle />
          <ContextMenu />
        </>
      )}
    </div>
  );
};
